import { get, post, remove } from "../common/http.services";

export function getOrderTask(taskSearchModel: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/task/order?page=${pageNumber}&size=${pageSize}`, taskSearchModel, appContext, success, error);
}

export function saveGeneralTask(model: any, appContext: any, success: any, error: any) {
    return post(`/task/general/save`, model, appContext, success, error);
}

export function saveTaskComments(model: any, appContext: any, success: any, error: any) {
    return post(`/task/general/comments`, model, appContext, success, error);
}

export function getGeneralTask(searchModel: any, pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return post(`/task/general/search?page=${pageNumber}&size=${pageSize}&sort=taskOwner,asc&sort=targetDate,asc`, searchModel, appContext, success, error);
}

export function getGeneralTaskById(rowId: any, appContext: any, success: any, error: any) {
    return get(`/task/general/findbyid?rowId=${rowId}`, appContext, success, error);
}

export function deleteGeneralTask(rowId: any, appContext: any, success: any, error: any) {
    return remove(`/task/general?rowId=${rowId}`, appContext, success, error);
}